import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('BackgroundShading').create(() => ({
  root: {
    position: 'absolute',
    width: '100%',
    backgroundImage: 'linear-gradient(to top, rgba(6, 7, 7, 1) 0%, rgba(6, 7, 7, 0.0) 100%)',
    zIndex: 2,
    pointerEvents: 'none',
  },
}))
